import React from "react"
import "./Loader.css"

const Loader = ({ loading, children, className = "", ...props }) => (
  <div
    className={`${className}`.trim()}
    {...props}
  >
    {loading ? (
      <span className={`loader-spinner ${className}`.trim()} aria-label="Loading..." />
    ) : (
      children
    )}
  </div>
);

export default Loader;